import React from "react";
import { ConvResumo, WhatsAppLead } from "services/api/AppWeb_WhatsApp/types";
import { avatarColor, iniciais, tempoRelativo } from "../utils";
import * as S from "../styles";

interface ContatoItemProps {
  lead: WhatsAppLead;
  resumo?: ConvResumo;
  ativo: boolean;
  onClick: () => void;
  timeReference?: number;
}

const ContatoItem: React.FC<ContatoItemProps> = ({
  lead,
  resumo,
  ativo,
  onClick,
  timeReference,
}) => {
  const unread = (resumo?.naoLidas ?? 0) > 0;

  return (
    <S.ContactItem active={ativo} onClick={onClick}>
      <S.Avatar bgColor={avatarColor(lead.id)} size={48}>
        {iniciais(lead.nome)}
        {lead.fotoUrl && (
          <S.AvatarImg
            src={lead.fotoUrl}
            alt=""
            referrerPolicy="no-referrer"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        )}
      </S.Avatar>
      <S.ContactInfo>
        <S.ContactRow>
          <S.ContactName bold={unread}>{lead.nome}</S.ContactName>
          {resumo?.data && (
            <S.ContactTime highlight={unread}>
              {tempoRelativo(resumo.data, timeReference)}
            </S.ContactTime>
          )}
        </S.ContactRow>
        <S.ContactPreviewRow>
          <S.ContactPreview bold={unread}>
            {resumo?.ultimaMensagem ?? lead.telefone}
          </S.ContactPreview>
          {unread && (
            <S.UnreadBadge>
              {(resumo?.naoLidas ?? 0) > 9 ? "9+" : resumo?.naoLidas}
            </S.UnreadBadge>
          )}
        </S.ContactPreviewRow>
      </S.ContactInfo>
    </S.ContactItem>
  );
};

export default ContatoItem;
